import { useState } from 'react';
import { HorizontalLayout, VerticalLayout } from '../common/common-layout';
import { LeftMenuState, homeMenuStore } from '../store/HomeMenuStore';
import BTBox from '../common/components/BTBox';
import { useNavigate } from 'react-router-dom';
import HomeLogo from '../assets/icons/home_logo.svg';
import LeftItem1 from '../assets/icons/left_item_1.svg';
import LeftItem2 from '../assets/icons/left_item_2.svg';
import LeftItem3 from '../assets/icons/left_item_3.svg';
import LeftItem4 from '../assets/icons/left_item_4.svg';
import LeftItem5 from '../assets/icons/left_item_5.svg';
import LeftItem6 from '../assets/icons/left_item_6.svg';
import LeftItem7 from '../assets/icons/left_item_7.svg';
import LeftItem8 from '../assets/icons/left_item_8.svg';
import Logout from '../assets/icons/logout.svg';
import { TextLeftMenuSection } from '../common/common-text';
import BTSelectItem from '../common/components/BTSelectItem';
import { Button } from '@mui/material';
import { authStore } from '../store/AuthStore';
import theme from '../common/theme';
import { observer } from 'mobx-react-lite';


const MainLeftMenu = observer(() => {
    const navigate = useNavigate();
    const selectedItem = homeMenuStore.getSelectedIndex();
    const user = authStore.user;
    const isSuperUser = user?.isSuperUser || false;

    const handleSelect = (index: number) => {
        homeMenuStore.selectByIndex(index);

        switch (homeMenuStore.getMenuState()) {
            case LeftMenuState.LEFT_MENU_1: {
                navigate('/homepage/inquiries');
                break;
            }

            case LeftMenuState.LEFT_MENU_2: {
                navigate('/homepage/reports');
                break;
            }
            case LeftMenuState.LEFT_MENU_3: {
                navigate('/homepage/contactperson');
                break;
            }
            case LeftMenuState.LEFT_MENU_4: {
                navigate('/homepage/info');
                break;
            }
            case LeftMenuState.LEFT_MENU_5: {
                navigate('/homepage/requesthomepagework');
                break;
            }
            case LeftMenuState.LEFT_MENU_6: {
                navigate('/board/marketing');
                break;
            }
            case LeftMenuState.LEFT_MENU_7: {
                navigate('/board/recruit');
                break;
            }
            case LeftMenuState.LEFT_MENU_8: {
                navigate('/board/patent');
                break;
            }
            case LeftMenuState.LEFT_MENU_9: {
                navigate('/board/notice');
                break;
            }
            case LeftMenuState.LEFT_MENU_10: {
                navigate('/account');
                break;
            }
            case LeftMenuState.LEFT_MENU_11: {
                navigate('/archive/bbboard');
                break;
            }
            case LeftMenuState.LEFT_MENU_12: {
                navigate('/archive/interboard');
                break;
            }
            case LeftMenuState.LEFT_MENU_13: {
                navigate('/archive/bbgallery');
                break;
            }
            case LeftMenuState.LEFT_MENU_14: {
                navigate('/archive/intergallery');
                break;
            }
            case LeftMenuState.LEFT_MENU_15: {
                navigate('/board/post/create');
                break;
            }
            // 다른 메뉴 상태에 대한 경로 설정을 추가할 수 있습니다.
            default:
                // 기본 동작 (필요시)
                break;
        }
    };

    const handleLogout = async () => {
        await authStore.logout();
    };

    return (
        <VerticalLayout
            width={300}
            paddingTop={0}
            backgroundColor={theme.colors.bbTech}
            style={{ minWidth: 300, display: 'flex', flexDirection: 'column', 
                minHeight: '100vh', // 화면보다 작을 때는 최소 100vh
    height: 'auto'       // 컨텐츠가 많으면 높이 자동 증가
             }} // 전체 높이 지정
        >
            <div>
                <HorizontalLayout
                    paddingLeft={0}
                    wrapContents={true}
                    style={{ alignItems: 'center', height: 'auto' }}
                >
                    <div style={{ width: 300 }}>
                        <img
                            src={HomeLogo}
                            alt="Logo"
                            width={300}
                            height={97}
                            style={{ cursor: 'pointer' }} // 커서 모양 변경 (선택사항)
                            onClick={() => navigate('/')} // 클릭 시 루트로 이동
                        />
                    </div>
                </HorizontalLayout>

                <TextLeftMenuSection>홈페이지 관리</TextLeftMenuSection>
                <BTSelectItem icon={<img src={LeftItem1} />} text="문의하기 관리" selected={selectedItem === 0} onClick={() => handleSelect(0)} />
                {isSuperUser && (
                    <BTSelectItem icon={<img src={LeftItem2} />} text="BB열린소리 관리" selected={selectedItem === 1} onClick={() => handleSelect(1)} />
                )}
                <BTSelectItem icon={<img src={LeftItem3} />} text="담당자 관리" selected={selectedItem === 2} onClick={() => handleSelect(2)} />
                <BTSelectItem icon={<img src={LeftItem4} />} text="홈페이지 정보 관리" selected={selectedItem === 3} onClick={() => handleSelect(3)} />
                <BTSelectItem icon={<img src={LeftItem5} />} text="홈페이지 유지보수 요청" selected={selectedItem === 4} onClick={() => handleSelect(4)} />

                <BTBox height="8px" />
                <BTBox height="1px" width="346px" backgroundColor="#FFFFFF33" />
                <BTBox height="8px" />

                <TextLeftMenuSection>게시판 컨텐츠 관리</TextLeftMenuSection>
                <BTSelectItem icon={<img src={LeftItem6} />} text="홍보 게시판 관리" selected={selectedItem === 5} onClick={() => handleSelect(5)} />
                <BTSelectItem icon={<img src={LeftItem6} />} text="채용공고 게시판 관리" selected={selectedItem === 6} onClick={() => handleSelect(6)} />
                <BTSelectItem icon={<img src={LeftItem6} />} text="특허 게시판 관리" selected={selectedItem === 7} onClick={() => handleSelect(7)} />
                <BTSelectItem icon={<img src={LeftItem6} />} text="공지사항 게시판 관리" selected={selectedItem === 8} onClick={() => handleSelect(8)} />


                <BTBox height="8px" />
                <BTBox height="1px" width="346px" backgroundColor="#FFFFFF33" />
                <BTBox height="8px" />

                {isSuperUser && (
                    <>
                        <TextLeftMenuSection>계정 및 보안 관리</TextLeftMenuSection>
                        <BTSelectItem icon={<img src={LeftItem7} />} text="관리자 계정 관리" selected={selectedItem === 9} onClick={() => handleSelect(9)} />

                        <BTBox height="8px" />
                        <BTBox height="1px" width="346px" backgroundColor="#FFFFFF33" />
                        <BTBox height="8px" />
                    </>
                )}

                <TextLeftMenuSection>아카이브</TextLeftMenuSection>
                <BTSelectItem icon={<img src={LeftItem6} />} text="BB게시판" selected={selectedItem === 10} onClick={() => handleSelect(10)} />
                <BTSelectItem icon={<img src={LeftItem6} />} text="사내전용게시판" selected={selectedItem === 11} onClick={() => handleSelect(11)} />
                <BTSelectItem icon={<img src={LeftItem8} />} text="BB갤러리" selected={selectedItem === 12} onClick={() => handleSelect(12)} />
                <BTSelectItem icon={<img src={LeftItem8} />} text="사내전용갤러리" selected={selectedItem === 13} onClick={() => handleSelect(13)} />
                {
                    // 아카이브 게시판 백업용
                    // <BTSelectItem icon={<img src={LeftItem4} />} text="게시판 백업" selected={selectedItem === 14} onClick={() => handleSelect(14)} />
                }
            </div>

            {/* ✅ 하단 고정 로그아웃 버튼 */}
            <div
                style={{
                    marginTop: 'auto',
                    marginRight: '32px',
                    marginBottom: '16px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '90%',
                }}
            >
                <Button
                    onClick={handleLogout}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                        border: 'none',
                        color: 'white',
                        fontSize: '16px',
                        cursor: 'pointer',
                        fontWeight: 700,
                        padding: 0,
                        gap: '8px',
                        outline: 'none',
                        userSelect: 'none',     // 텍스트 선택도 방지
                    }}
                    onMouseDown={(e) => e.preventDefault()} // 마우스 클릭 시 포커스 방지
                >
                    <img src={Logout} />
                    로그아웃
                </Button>

            </div>
        </VerticalLayout>

    );
});

export default MainLeftMenu;